import { Pencil } from 'lucide-react';
import React from 'react';
import Bar from '../../../../components/elements/Bar';
import Tree from './RightsTree';
const itemTrea = (item, changeRules) => {
  const _changeRules = (value) => {
    changeRules(item.id, value);
  };

  if (item.children.length === 0) {
    return (
      <Tree
        key={item.id}
        content={item.title}
        status={item.status}
        visible
        open
        changeRules={_changeRules}
      />
    );
  }
  return (
    <Tree
      key={item.id}
      content={item.title}
      status={item.status}
      canHide
      visible
      open
      changeRules={_changeRules}
    >
      {item.children.map((child) => itemTrea(child, changeRules))}
    </Tree>
  );
};

const makeTree = (data, changeRules) => {
  return (data || []).map((ele) => itemTrea(ele, changeRules));
};

const Header = () => (
  <div className="text-(--ink-600) text-sm h-[30px] items-center flex justify-between border-b border-dotted border-color3 pl-[10px]">
    <span>Část</span>
    <span className="flex">
      <span className="justify-center w-[70px] flex">Čtení</span>
      <span className="justify-center w-[70px] flex">Editace</span>
      <span className="justify-center w-[70px] flex">Odepřít</span>
    </span>
  </div>
);

export default function RightsDetailView({ data, changeRules, makeEditable, permission }) {
  if (!data) {
    return null;
  }
  return (
    <div className="w-full overflow-y-auto">
      <Bar
        text={'Nastavení oprávnění'}
        content={
          permission === 2
            ? [
                <Pencil
                  key={1}
                  className="h-4 w-4"
                  data-testid="rights-detail-edit-btn"
                  onClick={makeEditable}
                />,
              ]
            : []
        }
      />
      {data && <Header />}
      {makeTree(data, changeRules)}
    </div>
  );
}
